import { useTranslation } from 'react-i18next';

import { LoginState } from 'pages/Auth/contexts/LoginStateContext/LoginStateContext';
import { useLoginState } from 'pages/Auth/contexts/LoginStateContext/useLoginState';
import { SupplierLogo } from 'components/OrderForms/SupplierLogo/SupplierLogo';

export function LoginHeading({ supplierName }: { supplierName: string }) {
  const { t } = useTranslation();
  const { loginState } = useLoginState();

  return (
    <div className="flex flex-col items-center">
      <SupplierLogo className="mb-6" />
      <h1 className="mb-4 text-2xl leading-8 font-extrabold text-gray-900">
        {loginState === LoginState.passwordlessSuccess
          ? t('auth:heading.passwordlessSuccess')
          : t('auth:orderForm.loginHeading')}
      </h1>
      {loginState !== LoginState.passwordlessSuccess && (
        <p className="mb-10 text-center text-base leading-6 font-normal text-gray-500">
          {t('auth:orderForm.loginText', { supplierName })}
        </p>
      )}
    </div>
  );
}
